import type { DefaultNamespace } from 'i18next'
import type { FC, ReactNode } from 'react'
import { ButtonLegacy } from '@/components/ui/button-legacy'
import { Trash01Icon } from '@/components/ui/icons'
import { Modal } from '@/components/ui/modal'
import { Spinner } from '@/components/ui/spinner'
import { useTranslation } from '@/translations/i18n'

interface DeleteUserModalProps {
	isLoading: boolean
	onClose: () => void
	onDelete: () => void
	title: string | DefaultNamespace
	paragraph: ReactNode
}

export const DeleteModal: FC<DeleteUserModalProps> = ({
	isLoading,
	onClose,
	onDelete,
	title,
	paragraph
}) => {
	const { t } = useTranslation()

	return (
		<Modal
			closeIconOffset='sm'
			onClose={onClose}
			onOverlayClick={onClose}
			width={544}
		>
			<div className='p-6'>
				<div className='flex gap-4'>
					<Trash01Icon
						className='box-content fill-danger-600 p-3'
						size={24}
					/>
					<div>
						<h3 className='font-semibold text-lg text-neutral-900'>
							{title}
						</h3>
						<p className='mt-1 text-sm'>{paragraph}</p>
					</div>
				</div>
				<div className='mt-8 flex justify-end gap-4'>
					<ButtonLegacy
						disabled={isLoading}
						onClick={onClose}
						type='button'
						variant='secondary'
					>
						{t('common:cancel')}
					</ButtonLegacy>
					<ButtonLegacy
						disabled={isLoading}
						onClick={onDelete}
						type='button'
						variant='primaryDanger'
					>
						{t('common:delete')}
						{isLoading && <Spinner size={16} />}
					</ButtonLegacy>
				</div>
			</div>
		</Modal>
	)
}

DeleteModal.displayName = 'DeleteModal'
